import React from 'react';

const SvgComponent = props => (
  <svg width={20} height={20} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.543 19.654c0-1.776-1.981-1.776-1.981 0 0 1.777-2.221 1.794-2.221 0s-2.22-1.776-2.22 0c0 1.794-2.213 1.794-2.222 0 0-1.785-2.22-1.776-2.22 0 0 1.777-2.221 1.794-2.221 0s-2.22-1.776-2.22 0c0 1.777-2.222 1.812-2.222 0S1 17.878 1 19.654M20.543 15.213c0-1.777-1.981-1.777-1.981 0 0 1.776-2.221 1.794-2.221 0 0-1.795-2.22-1.777-2.22 0 0 1.794-2.213 1.794-2.222 0 0-1.786-2.22-1.777-2.22 0 0 1.776-2.221 1.794-2.221 0 0-1.795-2.22-1.777-2.22 0 0 1.776-2.222 1.812-2.222 0S1 13.436 1 15.213"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.326 13.996V3.22a2.222 2.222 0 0 1 4.442 0v.888M16.545 16.039V3.22a2.222 2.222 0 0 1 4.441 0v.888M10.326 8.995h6.218M10.326 6.33h6.218M10.326 11.66h6.218"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
